import React, { useEffect, useState } from 'react'
import styles from './Navbar.module.css'
import { Link, Location, useNavigate } from 'react-router-dom';
import logoDark from '../../assets/images/hard-creative-studio-logotype-pretol-blue.svg';
import logoLight from '../../assets/images/hard-creative-studio-logotype-lavender.svg';
import IconComponent from '../IconComponent/IconComponent';
import { AiOutlineMenu } from 'react-icons/ai';
import { FaArrowUp } from 'react-icons/fa';
import { sanityClient } from '../../lib/sanity.client';
import { ProjectTypes } from '../../lib/types/projectTypes';
import { Lang, useTranslation } from '../../TranslationProvider';

export type NavbarProps = {
    location: Location<any>;
    theme: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
}

const Navbar = (props: NavbarProps) => {

    const { currLang, setCurrLang } = useTranslation(); // ✅ use context here
    const navigate = useNavigate();
    const [isLanding, setIsLanding] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrollingDown, setScrollingDown] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [projectsTypes, setProjectsTypes] = useState<ProjectTypes[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1100);
    const { t } = useTranslation();

    function changeLang(lang: string) {
        if(currLang !== lang){
            setCurrLang(lang as Lang);
        }
    }

    const openType = (search: string) => {
        props.setSearch(search);
        setMenuOpen(false);
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1100);
            if (window.innerWidth >= 1100) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

useEffect(() => {
    (sanityClient as any).fetch(`*[_type == "typeProject" && showType == "Visible"] | order(order asc){
        ...
    }`)
    .then((data: any[]) => {
        setProjectsTypes(data);
    })
    .catch(console.error);
}, []);


    useEffect(() => {
        props.location.pathname.toString() === "/" ? setIsLanding(true) : setIsLanding(false);
    }, [props.location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                setScrollingDown(true);
            } else {
                setScrollingDown(false);
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : 'auto';
    }, [menuOpen]);
    return (
        <div 
            className={menuOpen ? styles.menuOpen : styles.container}
            style={{
                backgroundColor: isLanding ? 'transparent' : "#021526",
                top: scrollingDown ? '-100px' : 0
            }}
        >
            <div className={styles.items}>
                <div className={`${styles.item} ${styles.logo}`}>
                    <img src={`${props.theme === 'Dark' && menuOpen === false ? logoDark : logoLight}`} alt="" onClick={() => { navigate("/"); setMenuOpen(false); }} />
                    <div className={styles.menu} onClick={() => setMenuOpen(!menuOpen)}>
                        <IconComponent icon={AiOutlineMenu} size={30} />
                    </div>
                </div>
                <div className={`${styles.item} ${styles.nav_links}`}>
                    <Link to="/about" onClick={() => setMenuOpen(false)}>{t('about_us')}</Link>
                    {isMobile ? (
                        <>
                            {projectsTypes.map((item, index) => (
                                <Link key={index} to={`/projects/`} onClick={() => openType(item.type[currLang])}>{item.type[currLang]}</Link>
                            ))}
                        </>
                    ) : (
                        <Link to="/projects" onClick={() => setMenuOpen(false)}>{t('projects')}</Link>
                    )}
                    <Link to="/about#contact" onClick={() => setMenuOpen(false)}>{t('contact_us')}</Link>
                </div>
                <div className={`${styles.item} ${styles.language_wrapper}`}>
                    <div className={styles.social_media}>
                        <a href="https://www.instagram.com/hard.creative/" target='_blank' rel="noreferrer">
                            <span>Instagram</span>
                            <span className={styles.icon_btn}><IconComponent icon={FaArrowUp} size={15} /></span>
                        </a>
                        <a href="https://instagram.com" target='_blank' rel="noreferrer">
                            <span>Tiktok</span>
                            <span className={styles.icon_btn}><IconComponent icon={FaArrowUp} size={15} /></span>
                        </a>
                        <a href="https://open.spotify.com/playlist/3tpZMTlZCFZeAUCDHp7VuJ?si=8b53f40540504f25" target='_blank' rel="noreferrer">
                            <span>Playlist</span>
                            <span className={styles.icon_btn}><IconComponent icon={FaArrowUp} size={15} /></span>
                        </a>
                    </div>
                    <div className={styles.langs}>
                        <span className={`${currLang === "en" && styles.curr_lang}`} onClick={() => changeLang("en")}>EN</span>
                        <span>|</span>
                        <span className={`${currLang === "pt" && styles.curr_lang}`} onClick={() => changeLang("pt")}>PT</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar
